import { makeStyles } from "@material-ui/core";
import firebase from "firebase/app";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Footer } from "v2/components/footer";
import { Header } from "v2/components/hearder";
import { CustomDialog } from "views/dialog";
import { addBooking } from "../../actions/bookingactions";
import { usersRef } from "../../config/firebase";
import BackArrow from "@material-ui/icons/ArrowBack";
const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  center: {
    display: "flex",
    justifyContent: "center",
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
    },
  },
  item: {
    background: "rgba(196, 196, 196, 0.14)",
    padding: 20,
    margin: 20,
    width: "40%",
    borderRadius: 15,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
    },
  },
  itemcarousel: {
    padding: 0,
    margin: 20,
    width: "100%",
    marginTop: "auto",
    marginBottom: "auto",
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  title: {
    fontWeight: 600,
    paddingLeft: 18,
    color: "#afaaaa",
    marginBottom: 50,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    border: "rgba(196, 196, 196, 0.14)",
  },
  field: {
    padding: 16,
    width: "100%",
    fontWeight: 600,
    fontSize: 16,
    height: 50,
    border: "rgba(196, 196, 196, 0.14)",
    background: "white",
    "&>*": {
      border: "rgba(196, 196, 196, 0.14)",
    },
    "&>.MuiInput-root": {
      fontWeight: 600,
      fontSize: 16,
    },
  },
  divInput: {
    padding: 16,
    display: "flex",
    justifyContent: "space-between",
  },
  btn: {
    padding: 16,
    width: "100%",
    fontWeight: 700,
    fontSize: 14,
    border: "rgba(196, 196, 196, 0.14)",
    background: "#C4C4C4",
    cursor: "pointer",
  },
  logo: {
    marginRight: "auto",
    display: "flex",
    marginLeft: 15,
    cursor: "pointer",
  },
  price: {
    color: "#111",
    marginLeft: 10,
  },
  dialogRoot: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    "&>div": {
      margin: 20,
      padding: 16,
      display: "flex",
      justifyContent: "center",
    },
  },
  continueBtn: {
    background: "#DDBB78",
    width: "100%",
    height: 60,
    border: "#DDBB78",
    fontWeight: 700,
    fontSize: 16,
    paddingLeft: 16,
    paddingRight: 16,
    cursor: "pointer",
  },
  tkxBtn: {
    fontSize: 16,
    marginLeft: "auto",
    marginRight: "auto",
    textAlgin: "center",
    height: 60,
    border: "#FFF",
    background: "transparent",
    cursor: "pointer",
  },
  msg: {
    fontSize: 16,
    marginLeft: "auto",
    marginRight: "auto",
    padding: 16,
    textAlgin: "center",
  },
}));

const defaultForm = {
  lastname: "",
  firstname: "",
  email: "",
  telephone: "",
};

const url = "https://shielded-oasis-59520.herokuapp.com/";

export default function Confirmation(props) {
  const styles = useStyles();
  const [commandeForm, setCommandeForm] = React.useState(defaultForm);
  const [openDialog, setDialogOpen] = React.useState(false);
  const [commandeInfo, setCommandeInfo] = React.useState({});
  const auth = useSelector((state) => state.auth);
  const [userUID, setUserUID] = React.useState(null);
  const dispatch = useDispatch();
  const [openLastMessage, setOpenLastMessage] = React.useState(false);
  React.useEffect(() => {
    setCommandeInfo(JSON.parse(props.history.location.state.commandeInfo));
  }, []);
  const onChangeHandler = (eventCahange) => {
    eventCahange.persist();
    setCommandeForm((prev) => ({
      ...prev,
      [eventCahange.target.name]: eventCahange.target.value,
    }));
  };
  const sendEmail = React.useCallback(async (body) => {
    console.log({ body });
    const headers = {
      "Content-Type": "application/json",
      mode: "same-origin",
    };
    return await fetch(url, {
      headers,
      method: "POST",
      body: JSON.stringify(body),
    });
  }, []);
  const handlerForm = async (data) => {
    data.persist();
    data.preventDefault();
    if (auth.info) {
      setUserUID(firebase.auth().currentUser.uid);
      confirmBooking(auth.info);
    } else {
      const ref = await usersRef.push({
        firstName: commandeForm.firstname,
        lastName: commandeForm.lastname,
        email: commandeForm.email,
        mobile: commandeForm.telephone,
        usertype: "rider",
        createdAt: new Date().toISOString(),
        signupViaReferral: false,
        refferalId:
          commandeForm.firstname + Math.floor(1000 + Math.random() * 9000),
        walletBalance: 0,
      });
      setUserUID(ref.getKey());
      const detail = await (await ref.once("value")).val();
      confirmBooking({
        uid: ref.key,
        profile: detail,
      });
    }
    handleOpenDialog();
    props.history.location.state = null;
    setOpenLastMessage(false);
  };

  const onCloseDialgo = () => {
    setDialogOpen(false);
    props.history.goBack();
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const confirmBooking = async (userDetails) => {
    dispatch(
      addBooking({
        pickup: commandeInfo.depart,
        drop: commandeInfo.destination,
        carDetails: commandeInfo.voiture,
        userUID,
        estimate: commandeInfo.estimate,
        tripdate: new Date(commandeInfo.jour).toString(),
        bookLater: true,
        userDetails: auth.info ?? userDetails,
      })
    );
    const body = {
      email: commandeForm.email,
      name: `${commandeForm.firstname} ${commandeForm.lastname}`,
      mobile: commandeForm.telephone,
    };

    try {
      const response = await sendEmail(body);
    } catch (error) {
    }
  };

  const back = React.useCallback(() => props.history.goBack());

  return (
    <div className={styles.root}>
      <Header />
      <div className={styles.center}>
        <div className={styles.item}>
          <div className={styles.logo} onClick={back}>
            <BackArrow />
          </div>
          <div>
            <h3 className={styles.title}>
              Le prix de la commande est de
              <span className={styles.price}> {commandeInfo.totalCost} F</span>.
            </h3>
          </div>

          <div>
            <form className={styles.form} method="post" onSubmit={handlerForm}>
              <div className={styles.divInput}>
                <input
                  placeholder="Votre Prénom"
                  minLength="2"
                  required
                  className={styles.field}
                  value={commandeForm.jour}
                  name="firstname"
                  onChange={onChangeHandler}
                />
                <input
                  style={{
                    marginLeft: 10,
                  }}
                  placeholder="Votre Nom"
                  className={styles.field}
                  value={commandeForm.heure}
                  name="lastname"
                  onChange={onChangeHandler}
                  required
                  minLength="2"
                />
              </div>

              <div className={styles.divInput}>
                <input
                  placeholder="Votre Téléphone"
                  className={styles.field}
                  type="tel"
                  value={commandeForm.heure}
                  name="telephone"
                  onChange={onChangeHandler}
                  required
                  pattern="^((\+|00)(221))?[7|3|8]{1}[0|7|5|0|6|8]{1}[0-9]{7}"
                />
              </div>

              <div className={styles.divInput}>
                <input
                  placeholder="Votre Email"
                  className={styles.field}
                  type="email"
                  value={commandeForm.heure}
                  name="email"
                  onChange={onChangeHandler}
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  required
                />
              </div>

              <div className={styles.divInput}>
                <button className={styles.btn} type="submit">
                  Commander
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
      <CustomDialog onClose={onCloseDialgo} onOpen={openDialog}>
        {openLastMessage && (
          <div className={styles.dialogRoot}>
            <div className={styles.msg}>
              Merci, de vous etre enregistrer! Un mail de confirmation a ete
              envoyer au {commandeForm.email}.
            </div>
            <div>
              <button className={styles.btn} onClick={onCloseDialgo}>
                OK
              </button>
            </div>
          </div>
        )}
        <div className={styles.dialogRoot}>
          <div className={styles.msg}>
            Votre commande a été bien prix en compte...
          </div>
          <div>
            <button className={styles.tkxBtn} onClick={onCloseDialgo}>
              Fermer
            </button>
          </div>
        </div>
      </CustomDialog>
    </div>
  );
}
